<template>
	<van-swipe
		vertical
		class="number-swiper"
		:autoplay="1500"
		:show-indicators="false"
	>
		<van-swipe-item v-for="(item, index) in dataList" :key="index">{{ item }}</van-swipe-item>
	</van-swipe>
</template>

<script>
	export default {
		name: 'numberSwiper',
		props: ['dataList']
	};
</script>

<style lang="less" scoped>
	.number-swiper {
		position: absolute;
		top:19px;
		right: 5px;
		width: 200px;
		height:12px;
		font-size:11px;
		text-align: left;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(124,86,30,1);
		line-height:12px;
	}
	.number-swiper /deep/ .van-swipe-item{
		text-overflow:ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
</style>
